// Re-export all config modules
export * from './api';
export { default as API_CONFIG } from './api';
export { default as subscriptionLimits } from './subscriptionLimits';

// Export API_BASE_URL for backward compatibility
export const API_BASE_URL = process.env.REACT_APP_API_URL || '';
